import { render } from "./HeartRateAlertSettingEditModal.vue?vue&type=template&id=6fa8265c&scoped=true&ts=true"
import script from "./HeartRateAlertSettingEditModal.vue?vue&type=script&lang=ts"
export * from "./HeartRateAlertSettingEditModal.vue?vue&type=script&lang=ts"

import "./HeartRateAlertSettingEditModal.vue?vue&type=style&index=0&id=6fa8265c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa8265c"]])

export default __exports__